__turbopack_context__.v({
  "className": "poppins_973a84e6-module__3N72nq__className",
  "variable": "poppins_973a84e6-module__3N72nq__variable",
});
